<template>
  <div
    :class="wrapperClass"
    :style="{ minHeight: $is_mobile_view ? '70vh' : '0px' }">
    <div class="mb-5" :class="containerClass">
      <!-- TAGLINE & SUBTAGLINE  -->
      <div class="w-100 mb-4">
        <p
          class="mb-0"
          :class="!$is_mobile_view ? 'heading-4-1' : 'heading-5-2'">
          {{ getActiveHotelModule.title }}
        </p>
        <p
          class="mb-0"
          v-if="$isNotEmptyV2(getActiveHotelModule.subtitle)"
          :class="!$is_mobile_view ? 'body-1' : 'body-2'">
          {{ getActiveHotelModule.subtitle }}
        </p>

        <!-- DEFAULT ADDITIONAL PRODUCT (REQUIRED ROOM) -->
        <div
          v-if="getActiveHotelModule.module === 'OTHER'"
          class="p-2-5 rounded-4 mb-3 d-inline-flex align-items-start mt-3"
          :class="{ 'w-100': $is_mobile_view }"
          style="
            border-left: 4px solid #17a2b8;
            background-color: rgba(23, 162, 184, 0.05);
            border-right: 1px solid #17a2b8;
            border-block: 1px solid #17a2b8;
          ">
          <div class="flex-shrink-0 mr-3">
            <svg
              width="26px"
              height="18px"
              viewBox="0 0 29 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path
                d="M23.7273 2.66667H13.1818V12H2.63636V0H0V20H2.63636V16H26.3636V20H29V8C29 6.58551 28.4445 5.22896 27.4557 4.22876C26.4668 3.22857 25.1257 2.66667 23.7273 2.66667ZM7.90909 10.6667C8.9579 10.6667 9.96376 10.2452 10.7054 9.49509C11.447 8.74495 11.8636 7.72753 11.8636 6.66667C11.8636 5.6058 11.447 4.58839 10.7054 3.83824C9.96376 3.08809 8.9579 2.66667 7.90909 2.66667C6.86028 2.66667 5.85443 3.08809 5.11281 3.83824C4.37118 4.58839 3.95455 5.6058 3.95455 6.66667C3.95455 7.72753 4.37118 8.74495 5.11281 9.49509C5.85443 10.2452 6.86028 10.6667 7.90909 10.6667Z"
                fill="#17A2B8" />
            </svg>
          </div>
          <div class="w-100 pt-1">
            <p class="body-2-4 mb-1">Required Room</p>
            <p class="body-3-1 mb-0">
              You must book a room to order a product from this category.
            </p>
          </div>
        </div>

        <!-- CATEGORY -->
        <div class="w-100 my-3" v-if="!pageStatus.isLoad && $isNotEmptyV2(category.list)">
          <div class="row slim-grid-row">
            <template v-if="viewType != 'mobile'">
              <div class="col-2" v-for="categoryItem in shownCategories">
                <div 
                  @click="selectCategory(categoryItem)"
                  class="border-form radius-6 text-center p-2 category-item" 
                  :class="categoryItem.id == category.selected.id ? 'bg-green border-green' : 'bg-white'">
                  <p class="text-truncate mb-0" :class="categoryItem.id == category.selected.id ? 'text-white body-3-3-2':'body-3'">{{ categoryItem.name }}</p>
                </div>
              </div>
            </template>

            <!-- MORE BUTTON -->
             <div class="col-12 col-sm-2" v-if="(viewType !== 'mobile' && category.list.length > 6) || viewType === 'mobile'">
              <CustomDropdown v-model="showMoreCategories" :min-width="300" :full-width="viewType === 'mobile'" :align="'right'">
                <template #trigger>
                  <div v-if="viewType === 'mobile'" class="px-2-5 py-2 d-flex align-items-center border-form rounded justify-content-between">
                    <p class="mb-0 body-2-4 mr-2-5 flex-shrink-0">{{ category.selected.name }}</p>
                    <svg class="delay" :class="{'transform-180' : showMoreCategories}" width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M6.52769 8C6.7155 8 6.90325 7.92487 7.031 7.78212L12.8451 1.82535C12.9727 1.69765 13.0479 1.53239 13.0479 1.3446C13.0479 0.953987 12.7549 0.653519 12.3643 0.653519C12.1765 0.653519 12.0037 0.728637 11.876 0.848825L6.12205 6.7305H6.92581L1.17182 0.848825C1.05164 0.728637 0.878869 0.653519 0.683569 0.653519C0.292957 0.653519 0 0.953987 0 1.3446C0 1.53239 0.0751175 1.69765 0.202816 1.83286L6.01689 7.78212C6.15961 7.92487 6.33238 8 6.52769 8Z" fill="#999999" />
                    </svg> 
                  </div>
                  <div v-else class="border-green radius-6 text-center p-2 bg-white">
                    <p class="body-3-3-2 text-green mb-0">MORE</p>
                  </div>
                </template>
                 <template #content>
                  <div class="w-100 p-2" style="max-height: 350px;overflow-y: auto;">
                    <div class="p-3 border-b-form category-item-dropdown" v-for="categoryItem in category.list" @click="selectCategory(categoryItem)">
                      <p class="mb-0" :class="categoryItem.id == category.selected.id ? 'body-2-4 text-green':'body-2-2'">{{ categoryItem.name }}</p>
                    </div>
                  </div>
                 </template>
              </CustomDropdown>
              
            </div>
          </div>
        </div>

      </div>
      <div class="row">
        <div :class="isNewDesign ? 'col-12' : 'col-md-9 col-12'">
          <div
            :class="
              $is_mobile_view ? '' : 'bg-light-desktop py-3 container rounded-4'
            ">
            <div class="row" v-if="pageStatus.isLoad">
              <div class="col-12 col-md-6 mb-4" v-for="i in 2">
                <div class="w-100">
                  <div class="row no-gutters">
                    <div class="col-4">
                      <div
                        class="w-100 radius-6 position-relative"
                        style="height: 110px; overflow: hidden">
                        <b-skeleton-img
                          no-aspect
                          height="110px"></b-skeleton-img>
                      </div>
                    </div>
                    <div class="col-8">
                      <div class="pl-3">
                        <b-skeleton
                          width="50%"
                          height="21.3333px"
                          class="mb-1"></b-skeleton>
                        <b-skeleton
                          width="100%"
                          height="16px"
                          class="mb-1"></b-skeleton>
                        <b-skeleton
                          width="30%"
                          height="18px"
                          class="mb-2"></b-skeleton>
                        <b-skeleton
                          width="30%"
                          height="32px"
                          class="d-table ml-auto"></b-skeleton>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <template v-else>
              <div class="py-4" v-if="pageStatus.error != ''">
                <ErrorMessage :message="pageStatus.error" />
              </div>
              <template v-else>
                <div class="row slim-grid-row mb-3">
                  <div
                    class="col-xl-6 col-12 mb-4"
                    v-for="(product, index) in currentProductList">
                    <GeneralProduct
                      v-if="categoryType === 'GENERAL'"
                      :data="product" />

                    <template v-else-if="categoryType == 'RESTAURANT'">
                      <div class="w-100" v-if="product.isShow">
                        <OutletProduct
                          type="block"
                          :data="product"
                          :index="index"
                          :pos="getActiveHotelModule.merchant_pos"
                          :products_length="productList.length"
                          page_module="additional_service" />
                      </div>
                      <div v-else class="w-100" v-lazy="() => showProduct(product.id)">

                      </div>
                    </template>
                      

                    <ActivityProduct
                      v-else-if="categoryType === 'ACTIVITY'"
                      :data="product"
                      :general_data="generalData"
                      page_module="additional_service" />

                    <VoucherProduct
                      v-else-if="categoryType === 'VOUCHER'"
                      :data="product"
                      page_module="additional_service" />
                  </div>
                </div>
              </template>
            </template>
          </div>
        </div>
        <div class="col-3" v-if="!($is_mobile_view || isNewDesign)">
          <SearchPreviewCart module="ADDITIONAL" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { get } from '@/services/index.js';
import GeneralProduct from '@/components/hotel/be/additionalService/Product';
import OutletProduct from '../concierge/pos/Product';
import ActivityProduct from '../concierge/activity/Product';
import VoucherProduct from '@/components/hotel/upselling/VoucherItem';
import SearchPreviewCart from './SearchPreviewCart.vue';
import CustomDropdown from '../../general/CustomDropdown.vue';

export default {
  components: {
    GeneralProduct,
    OutletProduct,
    ActivityProduct,
    VoucherProduct,
    SearchPreviewCart,
    CustomDropdown
  },
  data() {
    return {
      pageStatus: {
        isLoad: true,
        error: '',
      },
      productList: [],
      generalData: {},
      category:{
        list: [],
        selected: {}
      },
      showMoreCategories: false,
      isVisible: false,
      viewType: 'mobile'
    };
  },
  computed: {
    ...mapGetters(['getMerchant', 'getActiveHotelModule']),
    categoryType() {
      const { merchant_pos = null } = this.getActiveHotelModule;
      if (!this.$isNotEmpty(merchant_pos)) return 'GENERAL';

      switch (merchant_pos.pos_type) {
        case 'RESTAURANT':
          return 'RESTAURANT';
        case 'SPA':
        case 'ACTIVITY':
          return 'ACTIVITY';
        case 'VOUCHER':
          return 'VOUCHER';
        default:
          return '';
      }
    },
    isNewDesign() {
      return (
        this.getMerchant.booking_engine_header_type == 'MULTI_IMAGE_BANNER'
      );
    },
    wrapperClass() {
      if (this.isNewDesign) return 'w-100';
      return this.$is_mobile_view ? 'container' : 'px-3 mb-3 pt-4';
    },
    containerClass() {
      if (this.isNewDesign) return 'w-100';
      return this.$is_mobile_view ? '' : 'px-5';
    },
    currentProductList() {
      const isCategoryEmpty = this.$isEmpty(this.category.list);
      const isSelectedCategoryEmpty = this.$isEmpty(this.category.selected);
      const isSelectedACategoryAll = this.category.selected.id === 'all';
      if (isCategoryEmpty || isSelectedCategoryEmpty || isSelectedACategoryAll) return this.productList;
      return this.productList.filter(product => product.category.id === this.category.selected.id)
    },
    shownCategories(){
      if(this.category.list.length > 6) return this.category.list.slice(0, 5);
      return this.category.list;
    }
  },
  watch: {
    getActiveHotelModule() {
      this.loadConfigAndProduct();
    }
  },
  mounted() {
    this.initViewType();
    window.addEventListener('resize', this.initViewType);
    this.loadConfigAndProduct();
  },
  methods: {
    initViewType(){
      this.viewType = window.innerWidth > 576 ? 'desktop' : 'mobile';
    },
    async loadConfigAndProduct() {
      try {
        this.pageStatus = { isLoad: true, error: '' };

        const { id, merchant_pos = {}, page_module } = this.getActiveHotelModule;
        if (this.$isNotEmpty(merchant_pos) && page_module === 'ACTIVITY') {
          const isSpaModule = merchant_pos.pos_type === 'SPA';
          await this.getGeneralConfig(isSpaModule, merchant_pos.id);
        }

        await this.getProductList(id);
        await this.getCategoryList();
      } catch (error) {
        this.pageStatus.error = error.message || 'An unexpected error occurred';
      } finally {
        this.pageStatus.isLoad = false;
      }
    },
    async getGeneralConfig(isSpaModule = true, merchantPosId) {
      try {
        this.generalData = {};

        const apiConfig = {
          module: isSpaModule ? 'CONCIERGE' : 'CORE_HOTEL',
          url: isSpaModule
            ? 'spa/general'
            : `merchant-pos/${merchantPosId}/general`,
          params: { merchant_id: this.getMerchant.id },
        };
        const apiResponse = await get(
          apiConfig.module,
          apiConfig.url,
          apiConfig.params
        );

        const { success, data = null, message = '' } = apiResponse.data;
        if (!success) throw new Error(message);
        this.generalData = data;
      } catch (error) {
        throw error;
      }
    },
    async getProductList(categoryId) {
      try {
        const apiParams = {
          merchant_id: this.getMerchant.id,
          category_id: categoryId,
        };
        const apiResponse = await get(
          'CORE_HOTEL',
          'hotel-additional-service',
          apiParams
        );

        const { success, data = null, message = '' } = apiResponse.data;
        if (!success) throw new Error(message);
        this.productList = data.map(product => {
          product.isShow = false
          return product;
        });
      } catch (error) {
        throw error;
      }
    },
    async getCategoryList(){
      try {
        const { merchant_pos = {} } = this.getActiveHotelModule;
        if (this.$isEmpty(merchant_pos)) return;
        
        const posHaveCategory = ['SPA', 'RESTAURANT', 'ACTIVITY'];
        const isCurrentPOSAllowed = posHaveCategory.some(posType => posType === merchant_pos.pos_type);
        if(!isCurrentPOSAllowed) return;
        
        this.category = { list: [], selected: {} };

        const { id: posId } = merchant_pos;
        const apiResponse = await get("CORE_HOTEL", `merchant-pos/${posId}/product-category`, { 
          merchant_id: this.getMerchant.id,
          page_size: 100
        });

        const { success, data = null, message = '' } = apiResponse.data;
        if (!success) throw new Error(message);
        this.filterCategory(data);
      } catch (error) {
        throw error;
      }
    },
    filterCategory(data){
      const fixedCategory = data.filter(category => {
        return this.productList.some(product => product.category && product.category.id === category.id);
      })
      const orderdCategory = fixedCategory.sort((a, b) => (a.position_category > b.position_category ? 1 : -1));

      const uncategorizedProduct = this.productList.filter(product => !data.some(category => category.id === product.category.id) );

      if (fixedCategory.length === 1) return;
      
      this.category.list = orderdCategory;
      this.category.list.unshift({
        id: 'all',
        name: 'All Categories'
      })
      this.category.selected = this.category.list[0]
    },
    selectCategory(category){
      this.category.selected = category; 
      this.productList = this.productList.map(product => {
        product.isShow = false
        return product;
      });
      setTimeout(() => {
        this.showMoreCategories = false;
      }, 100);
    },
    showProduct(id){
      const productIndex = this.productList.findIndex(product => product.id === id);
      if(productIndex != -1){
        this.productList[productIndex].isShow = true;
      }
    }
  },
};
</script>
<style scoped>
.category-item{
  cursor: pointer;
  transition: 0.1s;
}
.category-item:hover{
  background-color: var(--merchant-primary-color)!important;
  border-color: var(--merchant-primary-color)!important;
}
.category-item:hover p {
  color: #fff !important;
  font-family: Nunito-Bold !important;
}
.category-item-dropdown{
  cursor: pointer;
  transition: 0.1s;
}
.category-item-dropdown:hover p {
  color: var(--merchant-primary-color) !important;
  font-family: Nunito-Bold !important;
}

@media screen and (max-width: 992px) {
  .px-5 {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
}

@media screen and (max-width: 1200px) {
  .px-5 {
    padding-left: 0.5rem !important;
    padding-right: 0.5rem !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/hotel/be/AdditionalModule.vue